import React from 'react'

import { Icon } from 'src/chrome'

import { IconTypeOrIconString } from 'src/app/types'

import styles from './fullWindowModal.module.scss'

type FullWindowModalProps = {
  close?: () => void
  closeIcon?: IconTypeOrIconString
  closeMessage?: string
  closeStyle?: React.CSSProperties
  style?: React.CSSProperties
}

const FullWindowModal: React.FC<FullWindowModalProps> = props => {
  const { children, close, closeIcon, closeMessage, closeStyle, style } = props
  return (
    <div className={styles.fullWindow} style={style}>
      {!!close && (
        <div
          className={styles.close}
          style={closeStyle}
          onClick={() => close()}
        >
          <div className={styles.icon}>
            <span className={styles.message}>{closeMessage || 'Close'}</span>
            &nbsp;
            <Icon icon={closeIcon || 'CLOSE'} size={16} />
          </div>
        </div>
      )}
      {children}
    </div>
  )
}

export default FullWindowModal
